import { render, staticRenderFns } from "./PermissionComponent.vue?vue&type=template&id=5e3a6cee&"
import script from "./PermissionComponent.vue?vue&type=script&lang=js&"
export * from "./PermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./PermissionComponent.vue?vue&type=style&index=0&id=5e3a6cee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports